export default  {
  tipoContratacao: {
      VD: 1,
      VMR: 2
  }
}


// WEBPACK FOOTER //
// ./src/helpers/tipo-contratacao-enum.js